import { render, staticRenderFns } from "./sharespermember.vue?vue&type=template&id=2ed32319"
import script from "./sharespermember.vue?vue&type=script&lang=js"
export * from "./sharespermember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports